/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/graphData.config.json';
import provConfig from '../config/provenance.config.json';

export interface IFormatOverviewDetailMethods extends IPluginMethodMap {
  getFormatOverviewDetailSync(args: any): any;
}

export class FormatOverviewDetailService implements IAgentPlugin {
  readonly methods: IFormatOverviewDetailMethods;

  constructor() {
    this.methods = {
      getFormatOverviewDetailSync: this.getFormatOverviewDetailSync.bind(this),
    };
  }

  getFormatOverviewDetailSync(args: any) {
    return {
      NODES: config?.NODES,
      EDGES: config?.EDGES,
      ATTRIBUTE_TYPES: config?.ATTRIBUTE_TYPES,
      SUPPLIERS_LIST: config?.SUPPLIERS_LIST,
      RECIPIENTS_LISTS: config?.RECIPIENTS_LISTS,
      COMPLIANCE_LIST: config?.COMPLIANCE_LIST,
      INITIAL_SUPPLIERS: config?.INITIAL_SUPPLIERS,
      INITIAL_RECIPIENTS: config?.INITIAL_RECIPIENTS,
      INITIAL_COMPLIANCE_PROOF: config?.INITIAL_COMPLIANCE_PROOF,
      PROVENANCE_DATA: { ...provConfig },
    };
  }
}
